import { useContext, useState } from "react";
import { ParagraphText } from "../../../../Libraries";
import { LanguageContext } from "../../../../context/LanguageContext";
import { Box, capitalize } from "@mui/material";
import { formatNum } from "../../../../oscar-pos-core/constants";
import { analytics, triggerLogEvent } from "../../../../config/firebase";
import { dateFormatInNumberWithSpace } from "../../../../utils";

const ItemList = ({ item, onSelect = () => {}, index, filters }) => {
  const [I18n] = useContext(LanguageContext);
  const [open, setOpen] = useState(false);

  const isSale = item?.type === "in";
  const isQuickSale = item?.tranType === "cash" && item?.type === "in";
  const isQuickExpense = item?.tranType === "cash" && item?.type === "out";
  const isPOS = item?.tranType === "pos" && item?.type === "in";
  const isSaleInvoice = item?.tranType === "bill" && item?.type === "in";
  const isPurchaseBill = item?.tranType === "bill" && item?.type === "out";
  let desc = isQuickSale
    ? I18n.quick_sale
    : isQuickExpense
      ? I18n.quick_expense
      : isPOS
        ? I18n.pos_sale
        : isSaleInvoice
          ? I18n.invoice_sale
          : isPurchaseBill
            ? I18n.purchase_order
            : "";

  let prefix =
    item?.invoice_prefix && item?.invoice_number
      ? `• ${item?.invoice_prefix?.replace("#", " #")}${item?.invoice_number}`
      : "";

  desc = `${desc} ${prefix}`;

  let capitalizeStatus = item?.["status"]
    ? capitalize(item["status"]?.toString())
    : "";

  return (
    <Box
      className="invoiceListTableBody accountTableHeaderMain"
      key={index}
      id={`${"uncategorize"}_${index}`}
      onClick={(e) => {
        if (open) return;
        e.stopPropagation();
        triggerLogEvent(analytics, "bo_category_item_click", {
          tran_type: item?.tranType,
          type: item?.type,
        });
        onSelect();
      }}
    >
      <Box
        className={`invListTableHeaderCol fiveColumn textLeft sidebarOption`}
      >
        <ParagraphText className="fontSize14 fontWeight400 truncateOneLine textLeft newFontColor">
          {dateFormatInNumberWithSpace(item?.transacted_at)}
        </ParagraphText>
      </Box>
      <Box className={`invListTableHeaderCol fiveColumn textLeft`}>
        <ParagraphText className="fontSize14 fontWeight400 truncateOneLine textLeft newFontColor">
          {isSale ? "Sale" : "Expense"}
        </ParagraphText>
      </Box>
      <Box className={`invListTableHeaderCol fiveColumn textLeft`}>
        <ParagraphText
          className={`fontSize14 fontWeight400 truncateOneLine textLeft newFontColor`}
        >
          {desc}
        </ParagraphText>
      </Box>
      <Box
        className={`invListTableHeaderCol fiveColumn textLeft`}
      >
        <ParagraphText
          className={`fontSize14 fontWeight400 truncateOneLine textLeft newFontColor`}
        >
          {(() => {
            // Display only: capitalizeStatus stays English for the colour check below
            const statusText = item["status"]
              ? capitalize(I18n[capitalizeStatus.toLowerCase()] || capitalizeStatus)
              : item?.amount - (item?.advance_amount || 0) > 0
                ? I18n.unpaid
                : I18n.paid;

            return statusText;
          })()}
        </ParagraphText>
      </Box>
      <Box className={`invListTableHeaderCol fiveColumn textCenter`}>
        <ParagraphText
          className={`fontSize14 fontWeight400 truncateOneLine textRight ${capitalizeStatus == "Paid" ? "newFontColor" : item?.type == "in" ? "foundationOrangeColor" : "foundationGreenColor"}`}
        >
          {`${isSale ? "+" : "-"}Rs. ${formatNum(item?.amount)}`}
        </ParagraphText>
      </Box>
    </Box>
  );
};

export default ItemList;
